// extracted by mini-css-extract-plugin
export default {"rootWrap":"ReqPassCodeEditTableCell_rootWrap__9D0OH"};